import Icon from '../components/Icon.vue'

Icon.register({
  'caret-up': {
    width: 320,
    height: 512,
    paths: [
      {
        d: 'M288.7 352h-257.3c-17.8 0-26.7-21.5-14.1-34.1l128.7-128.7c7.8-7.8 20.5-7.8 28.3 0l128.7 128.7c12.6 12.6 3.7 34.1-14.1 34.1z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/caret-up.js
// module id = 1157
// module chunks = 0